<template>
  <!--
    https://github.com/sagalbot/vue-select - Docs

  -->
  <vue-select
    :class="{
      'placeholder-not-showing': !showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': disabled,
      'vue-select__medium': isMedium
    }"
    :options="options"
    :placeholder="placeholder"
    :value="fullValue"
    @input="emitInput"
    :multiple="false"
    :clear-on-select="false"
    :hide-selected="true"
    :label="label"
    track-by="name"
    :debounce="250"
    :disabled="disabled"
    :on-search="searchOptions"
    :loading="loading"
  ></vue-select>
</template>

<script>
import VueSelect from 'vue-select'

const SIZE = {
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3
}

export default {
  components: {
    VueSelect
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    value: {
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    searchOptions: {
      type: Function,
      default: undefined
    },
    label: {
      type: String,
      default: 'Name'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    returnLabelAsValue: {  // this will return the value attribute of the selected value returned by the select
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: SIZE.LARGE
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedValue: null
    }
  },
  computed: {
    showPlaceholder () {
      return !this.fullValue
    },
    fullValue () {
      if (this.value && this.returnLabelAsValue && this.options.length) {
        return this.options.filter(v => v[this.label] === this.value)[0]
      } else if (this.value && this.returnLabelAsValue) {
        return this.value
      } else {
        return this.value
      }
    },
    isMedium () {
      return this.size === SIZE.MEDIUM
    }
  },
  methods: {
    preventTheDefault (e) {
      // Prevent enter key press to select an advertiser from submitting the form
      // This is a fix for the vue-select plugin
      if (e.keyCode === 13) {
        e.preventDefault()
      }
    },
    clear () {
      // will update the value as well
      this.selectedValue = null
      this.$emity('input', null)
    },
    emitInput (val) {
      if (!val) {
        // do nothing
      } else if (this.returnLabelAsValue && val[this.label]) {
        this.$emit('input', this.returnLabelAsValue ? (val ? val[this.label] : val) : val)
      } else {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  mounted () {
    this.searchInput = this.$el.querySelector('input[type=search]')
    this.searchInput.addEventListener('keypress', this.preventTheDefault)
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// StyledSelectNew.vue?d2715b38